import {
  REGIONS_LOAD_DATA,
  REGIONS_LOAD_DATA_SUCCESS,
  REGIONS_LOAD_DATA_FAILED
} from './available'
import _ from 'lodash'
import {RequestState} from "../../requestState";

export default {
  [REGIONS_LOAD_DATA](state) {
    state.fetchAllRegions = RequestState.Loading;
  },
  [REGIONS_LOAD_DATA_SUCCESS](state, regions) {
    state.fetchAllRegions = RequestState.Success;

    regions.forEach(element => {
      state.allRegionsMap[element.code] = element.text
    });
    state.regions = regions.map(region => {
      return {
        key: region.code,
        name: region.text,
        ...region
      }
    })
  },
  [REGIONS_LOAD_DATA_FAILED](state, error) {
    state.fetchAllRegions = RequestState.Failed;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/regions.js